import {
    StyleSheet
} from "react-native";

const stylesheet = StyleSheet.create({
    overlay: {
        ...StyleSheet.absoluteFill
    }
});
export default stylesheet;
